// PaymentAcknowledgement.js

import { Paper, Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const TreeAcknowledgement = ({
  applicationDetails,
  applicationNumber,
  basePath
}) => {
  const navigate = useNavigate();

  return (
    <Paper sx={{ borderRadius: 2, boxShadow: 3}}>
      <Typography variant="h4" sx={{ mb: 2, textAlign: 'center' }}>
        Payment Acknowledgement
      </Typography>
      <Typography>
        Hello <strong>{applicationDetails?.userName}</strong>,
      </Typography>

        <Typography sx={{ mt: 1 }}>
          Please be advised that your Tree Removal Application{' '}
          <strong>{applicationNumber}</strong> has been received. Please allow
          21 calendar days for the processing of your application. We will
          contact you if we require any additional information.
        </Typography>
     
      <Typography sx={{ mt: 1 }}>
        If you have any further questions, please contact us at{' '}
        <a
          href={`mailto:${'EngTreeRemoval'}@techgov.com`}
        >
          {'TreeRemoval' }@techgov.com
        </a>
        .
      </Typography>
      
        <Typography sx={{ mt: 1 }}>
          Please make sure to check your spam folder for emails regarding your
          application. Make sure emails are allowed from{' '}
          <a href={`mailto:EngTreeRemoval@techgov.com`}>
            EngTreeRemoval@techgov.com
          </a>
          .
        </Typography>
      
      <br />
      <Typography sx={{ mt: 1 }}>
        Thank you, <br />
        Engineering Dept.
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
        <Button
          variant="outlined"
          onClick={() => navigate(`${basePath}/application-list`)}
        >
          View My Applications
        </Button>
      </Box>
    </Paper>
  );
};

export default TreeAcknowledgement;
